export default (form_type) => {
  if (form_type == 'blockForm') {
    const block_form_mapping = {
      'IE': {
        "County Cavan": "CN",
        "County Clare": "CE",
        "County Westmeath": "WH",
        "County Longford": "LD",
        "County Munster": "M",
        "County Meath": "MH",
        "County Dublin": "DU",
        "County Carlow": "CW",
        "County Kerry": "KY",
        "County Kilkenny": "KK",
        "County Kildare": "KE",
        "County Wicklow": "WW",
        "County Connaught": "C",
        "County Cork": "CO",
        "County Donegal": "D",
        "County Galway": "G",
        "County Leinster": "L",
        "County Laois": "LS",
        "County Leitrim": "LM",
        "County Limerick": "LK",
        "County Wexford": "WX",
        "County Louth": "LH",
        "County Mayo": "MO",
        "County Monaghan": "MN",
        "County Offaly": "OY",
        "County Waterford": "WD",
        "County Roscommon": "RN",
        "County Sligo": "SO",
        "County Tipperary": "TA",
        "County Ulster": "U"
      }
    };

    return block_form_mapping;
  } else {
    const standard_form_mapping = {
      'ES': {
        "A Coruña": "C",
        "Alacant*": "A",
        "Albacete": "AB",
        "Almería": "AL",
        "Andalucía": "AN",
        "Araba*": "VI",
        "Aragón": "AR",
        "Asturias": "O",
        "Principado de Asturias": "AS",
        "Badajoz": "BA",
        "Barcelona": "B",
        "Bizkaia": "BI",
        "Burgos": "BU",
        "Canarias": "CN",
        "Cantabria": "S",
        "Cantabria": "CB",
        "Castelló*": "CS",
        "Castilla y León": "CL",
        "Castilla-La Mancha": "CM",
        "Catalunya": "CT",
        "Ceuta": "CE",
        "Ciudad Real": "CR",
        "Cuenca": "CU",
        "Cáceres": "CC",
        "Cádiz": "CA",
        "Córdoba": "CO",
        "Euskal Herria": "PV",
        "Extremadura": "EX",
        "Galicia": "GA",
        "Gipuzkoa": "SS",
        "Girona": "GI",
        "Granada": "GR",
        "Guadalajara": "GU",
        "Huelva": "H",
        "Huesca": "HU",
        "Illes Balears": "PM",
        "Illes Balears": "IB",
        "Jaén": "J",
        "La Rioja": "LO",
        "La Rioja": "RI",
        "Las Palmas": "GC",
        "León": "LE",
        "Lleida": "L",
        "Lugo": "LU",
        "Madrid": "M",
        "Comunidad de Madrid": "MD",
        "Melilla": "ML",
        "Murcia": "MU",
        "Región de Murcia": "MC",
        "Málaga": "MA",
        "Nafarroa*": "NA",
        "Nafarroako Foru Komunitatea*": "NC",
        "Ourense": "OR",
        "Palencia": "P",
        "Pontevedra": "PO",
        "Salamanca": "SA",
        "Santa Cruz de Tenerife": "TF",
        "Segovia": "SG",
        "Sevilla": "SE",
        "Soria": "SO",
        "Tarragona": "T",
        "Teruel": "TE",
        "Toledo": "TO",
        "Valencia": "V",
        "Comunidad Valenciana": "V",
        "Valladolid": "VA",
        "Zamora": "ZA",
        "Zargoza": "Z",
        "Ávila": "AV"
      },
      'IE': {
        "County Cavan": "CN",
        "County Clare": "CE",
        "County Westmeath": "WH",
        "County Longford": "LD",
        "County Munster": "M",
        "County Meath": "MH",
        "County Dublin": "D",
        "County Carlow": "CW",
        "County Kerry": "KY",
        "County Kilkenny": "KK",
        "County Kildare": "KE",
        "County Wicklow": "WW",
        "County Connaught": "C",
        "County Cork": "CO",
        "County Donegal": "DL",
        "County Galway": "G",
        "County Leinster": "L",
        "County Laois": "LS",
        "County Leitrim": "LM",
        "County Limerick": "LK",
        "County Wexford": "WX",
        "County Louth": "LH",
        "County Mayo": "MO",
        "County Monaghan": "MN",
        "County Offaly": "OY",
        "County Waterford": "WD",
        "County Roscommon": "RN",
        "County Sligo": "SO",
        "County Tipperary": "TA",
        "County Ulster": "U"
      }
    };

    return standard_form_mapping;
  }
}
